/* Nimble Menswear — behaviour for custom sections (slider, arrival dates, sticky add to cart). */
(function () {
  'use strict';

  /* ---------- Slider arrows ---------- */
  if (!customElements.get('nm-slider')) {
    customElements.define(
      'nm-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-nm-track]');
          this.prev = this.querySelector('[data-nm-prev]');
          this.next = this.querySelector('[data-nm-next]');
          if (!this.track) return;
          var self = this;
          var step = function (dir) {
            var item = self.track.firstElementChild;
            var gap = parseFloat(getComputedStyle(self.track).columnGap) || 0;
            var w = item ? item.getBoundingClientRect().width + gap : self.track.clientWidth;
            self.track.scrollBy({ left: dir * w, behavior: 'smooth' });
          };
          if (this.prev) this.prev.addEventListener('click', function () { step(-1); });
          if (this.next) this.next.addEventListener('click', function () { step(1); });
          var update = function () {
            var max = self.track.scrollWidth - self.track.clientWidth - 2;
            if (self.prev) self.prev.disabled = self.track.scrollLeft <= 2;
            if (self.next) self.next.disabled = self.track.scrollLeft >= max;
          };
          this.track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);
          update();
        }
      }
    );
  }

  /* ---------- Estimated arrival ---------- */
  if (!customElements.get('nm-arrival')) {
    customElements.define(
      'nm-arrival',
      class extends HTMLElement {
        connectedCallback() {
          var el = this.querySelector('.nm-pb-arrival__text');
          if (!el) return;
          var tpl = el.getAttribute('data-template') || '';
          if (tpl.indexOf('[start]') === -1 && tpl.indexOf('[end]') === -1) return;
          var locale = this.dataset.locale || undefined;
          var fmt = function (days) {
            var d = new Date();
            d.setDate(d.getDate() + (parseInt(days, 10) || 0));
            try {
              return d.toLocaleDateString(locale, { month: 'long', day: 'numeric' });
            } catch (e) {
              return d.toDateString();
            }
          };
          el.innerHTML = tpl.split('[start]').join(fmt(this.dataset.min)).split('[end]').join(fmt(this.dataset.max));
        }
      }
    );
  }

  /* ---------- Sticky add to cart ---------- */
  if (!customElements.get('nm-sticky-atc')) {
    customElements.define(
      'nm-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          var sectionId = this.dataset.section;
          // Move to <body> so the fixed bar is not clipped by sticky/transformed product columns.
          if (this.parentElement !== document.body) {
            // Dawn re-renders the product section on variant change: replace any earlier bar.
            document.querySelectorAll('body > nm-sticky-atc[data-section="' + sectionId + '"]').forEach(function (old) {
              if (old !== self) old.remove();
            });
            document.body.appendChild(this);
            return;
          }
          if (this._ready) return;
          this._ready = true;
          this.hidden = false;
          this.mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
          this.button = this.querySelector('[data-sticky-button]');
          try {
            this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          } catch (e) {
            this.variants = {};
          }

          this.button.addEventListener('click', function () {
            self.mainButton = document.getElementById('ProductSubmitButton-' + sectionId) || self.mainButton;
            if (!self.mainButton) return;
            if (self.mainButton.disabled) {
              self.mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
            self.mainButton.click();
          });

          if (this.dataset.mode === 'always' || !this.mainButton || !('IntersectionObserver' in window)) {
            this.classList.add('is-visible');
          } else {
            new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                var above = entry.boundingClientRect.top < 0;
                self.classList.toggle('is-visible', !entry.isIntersecting && above);
              });
            }).observe(this.mainButton);
          }

          // Keep variant, price and availability in sync with the main picker.
          var form = document.getElementById('product-form-' + sectionId);
          var sync = function () {
            var input = form && form.querySelector('input[name="id"]');
            var v = input && self.variants[input.value];
            if (!v) return;
            var t = self.querySelector('[data-variant-title]');
            if (t) t.textContent = v.title;
            var p = self.querySelector('[data-price]');
            if (p) p.textContent = v.price;
            var c = self.querySelector('[data-compare]');
            if (c) {
              c.hidden = !v.compare;
              if (v.compare) c.textContent = v.compare;
            }
            self.button.disabled = !v.available;
          };
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
          }
          document.addEventListener('change', function (e) {
            if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 50);
          });
        }
      }
    );
  }
})();
